﻿import { ridge2Client } from './ridge2/ridge2Client'

var client = new ridge2Client();
